import { render, staticRenderFns } from "./AvailabilityStatusBadge.vue?vue&type=template&id=23855d26&scoped=true&"
import script from "./AvailabilityStatusBadge.vue?vue&type=script&lang=js&"
export * from "./AvailabilityStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityStatusBadge.vue?vue&type=style&index=0&id=23855d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23855d26",
  null
  
)

export default component.exports